import React from "react";
import {observer} from "mobx-react";
import {Button, Card, Col, Container, Row} from "react-bootstrap";
import {Link} from "react-router-dom";
import HeroSection from "../../../components/HeroSection.jsx";

function ReportsPage() {
    return (
        <Container className="dashboard-shell">
            <HeroSection
                accent="muni"
                eyebrow="Reports"
                title="Reporting"
                subtitle="Open a report by type and run it on its own page."
            />

            <Card className="dashboard-panel mt-3">
                <Card.Header className="bg-white"><strong>Available reports</strong></Card.Header>
                <Card.Body>
                    <Row className="g-3">
                        <ReportLink
                            title="Monthly Sales Summary"
                            to="/taxAuth/reports/monthly-sales-summary"
                            description="Summarize completed billable sales transactions and revenue by day and month, with a final rollup."
                        />
                        <ReportLink
                            title="Sales Transactions"
                            to="/taxAuth/reports/sales-transactions"
                            description="List completed billable sales transactions with customer, payment, and pricing details plus totals."
                        />
                        <ReportLink
                            title="Non-Billable Orders"
                            to="/taxAuth/reports/non-billable-orders"
                            description="Review completed non-billable test orders placed against your tax system."
                        />
                    </Row>
                </Card.Body>
            </Card>
        </Container>
    );
}

function ReportLink({title, to, description}) {
    return (
        <Col md={6}>
            <Card className="h-100">
                <Card.Body>
                    <div className="d-flex justify-content-between align-items-center gap-3">
                        <div>
                            <h5 className="mb-1">{title}</h5>
                            <div className="text-muted small">{description}</div>
                        </div>
                        <Button as={Link} to={to} variant="outline-primary" size="sm">Open</Button>
                    </div>
                </Card.Body>
            </Card>
        </Col>
    );
}

export default observer(ReportsPage);
